import { faAngleDown, faGridDividers, faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import Button from 'components/UI/V3/Button/Button';
import DefaultHeader from 'components/UI/V3/DefaultHeader/DefaultHeader';
import DescriptionText from 'components/UI/V3/DescriptionText';
import { Dropdown, DropdownContent, DropdownTrigger } from 'components/UI/V3/Dropdown';
import { DropdownItem } from 'components/UI/V3/Dropdown/Item/DropdownItem';
import SearchBar from 'components/UI/V3/SearchBar/SearchBar';
import useIsMobile from 'hooks/useIsMobile';
import { FunctionComponent, useState } from 'react';
import styles from './EmailTemplatesHeader.module.scss';

interface EmailTemplatesHeaderProps {
    searchText: string;
    onChangeSearchText: (value: string) => void;
    onStartWithTemplate: () => void;
    onStartFromScratch: () => void;
    minimal?: boolean;
}

const EmailTemplatesHeader: FunctionComponent<EmailTemplatesHeaderProps> = ({
    searchText,
    onChangeSearchText,
    onStartWithTemplate,
    onStartFromScratch,
    minimal = false
}) => {
    const isMobile = useIsMobile();
    const [showMobileCreationModal, setShowMobileCreationModal] = useState(false);

    const newEmailButton = (
        <Button
            size={isMobile ? 'medium' : 'large'}
            label="New Email"
            rightIcon={faAngleDown}
            onClick={isMobile ? () => setShowMobileCreationModal(true) : undefined}
        />
    );

    const customButton = minimal ? undefined : isMobile ? (
        newEmailButton
    ) : (
        <Dropdown>
            <DropdownTrigger>{newEmailButton}</DropdownTrigger>

            <DropdownContent
                minWidth={170}
                align="end"
            >
                <DropdownItem
                    leftIcon={faGridDividers}
                    onSelect={onStartWithTemplate}
                >
                    Start With a Template
                </DropdownItem>
                <DropdownItem
                    leftIcon={faPenToSquare}
                    onSelect={onStartFromScratch}
                >
                    Start From Scratch
                </DropdownItem>
            </DropdownContent>
        </Dropdown>
    );

    return (
        <div className={styles.header}>
            <DefaultHeader
                title="Email Templates"
                customButton={customButton}
            />

            {!minimal && (
                <>
                    <DescriptionText
                        className={styles.headerDescription}
                        text="Design and send email campaigns to connect with your customers, increase bookings, or highlight special promotions."
                    />

                    <div className={styles.searchContainer}>
                        <SearchBar
                            searchText={searchText}
                            onChangeSearchText={onChangeSearchText}
                            placeholder="Search by email name"
                            className={styles.searchBar}
                        />
                    </div>
                </>
            )}

            {showMobileCreationModal && (
                <div
                    className={styles.mobileCreationOverlay}
                    onClick={() => setShowMobileCreationModal(false)}
                >
                    <div
                        className={styles.mobileCreationSheet}
                        onClick={event => event.stopPropagation()}
                    >
                        <div className={styles.mobileCreationHandle} />
                        <p className={styles.mobileCreationMessage}>
                            Template creation is only available on desktop or tablet. Please switch devices to continue.
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EmailTemplatesHeader;
